import React from 'react'
import { Formik, Field } from 'formik'
import { TextField } from 'material-ui'

const options = [{
  label: 'Confirm Id',
  name: 'confirmId',
  disabled: true
}, {
  label: 'ID',
  name: 'id',
  disabled: true
}, {
  label: 'Cart Id',
  name: 'cartId',
  disabled: true
}, {
  label: 'Order Date',
  name: 'orderDate',
  disabled: true
}, {
  label: 'Status',
  name: 'status',
  disabled: true
}, {
  label: 'Total',
  name: 'total',
  disabled: true
}, {
  label: 'Merchandise',
  name: 'merchandiseAmount',
  disabled: true
}, {
  label: 'Shipping',
  name: 'shippingAmount',
  disabled: true
}, {
  label: 'Discount',
  name: 'discountAmount',
  disabled: true
}, {
  label: 'Tax',
  name: 'taxAmount',
  disabled: true
}, {
  label: 'Tax Rate',
  name: 'taxrate',
  disabled: true
}, {
  label: 'Gift Card',
  name: 'giftcard',
  disabled: true
}, {
  label: 'Promo Code',
  name: 'promocode',
  disabled: true
}]


export class UserInformation extends React.Component {
  constructor(props) {
    super(props)
  }
render(){
  const { confirmId, id, cartId, orderDate, status, giftcard, promocode, taxrate, merchandiseAmount, taxAmount, 
    shippingAmount, discountAmount, totalAmount } = this.props.order
  const initialValues = {
    confirmId: confirmId || '',
    id: id || '',
    cartId: cartId || '',
    orderDate: new Date(orderDate).toLocaleString() || '',
    status: status || 'No Status Defined',
    salesChannelId: this.props.saleschannelName || '',
    merchandiseAmount: merchandiseAmount || 0,
    taxAmount: taxAmount || 0,
    shippingAmount: shippingAmount || 0,
    discountAmount: discountAmount || 0,
    taxrate: taxrate || '',
    giftcard: giftcard || '',
    promocode: promocode || '',
    total: totalAmount || '',
  }
  return (
    <div style={{ paddingLeft:'40px', paddingBottom: '20px' }}>
      <Formik
        initialValues={initialValues}
        enableReinitialize={true}
        render={(props) => (
            <div className="row">
              {options.map(({ label, name, disabled }) => (
                <div className="col-md-6 col-lg-4">
                  <Field name={name}>
                    {({ field }) => (
                      <div>
                        <TextField
                          {...field}
                          floatingLabelText={label}
                          floatingLabelStyle={this.props.styles.floatingLabelStyle}
                          floatingLabelFixed={true}
                          disabled={disabled}
                        />
                      </div>
                    )}
                  </Field>
                </div>
              ))}
              <div className="col-md-6 col-lg-4">
                <Field name='salesChannelId'>
                  {({ field, form }) => (
                    <div>
                      <TextField
                        {...field}
                        floatingLabelText={'Sales Channel'}
                        floatingLabelStyle={this.props.styles.floatingLabelStyle}
                        floatingLabelFixed={true}
                        disabled={true}
                      />
                      {form.touched[field.name]}
                    </div>
                  )}
                </Field>
              </div>
            </div>
        )}
      />
    </div>
  )
}
}

export default UserInformation;



// WEBPACK FOOTER //
// ./src/components/orders/Common/UserInformation.js